<div class="session-history">
  <div class="session-history__header">
    <h2 class="session-history__title">Vos conversations</h2>

    <button
      type="button"
      class="session-history__new-btn"
      (click)="onNewConversation()"
    >
      Nouvelle conversation
    </button>
  </div>

  <div class="session-history__body">
    @if (isLoading()) {
      <div class="session-history__status">
        <span class="session-history__spinner"></span>
        <span>Chargement de vos conversations…</span>
      </div>
    }

    @if (isError()) {
      <div class="session-history__status session-history__status--error">
        <span>Impossible de charger vos conversations : vérifiez votre connexion et réessayez.</span>
        <button type="button" class="session-history__retry-btn" (click)="onRetry()">
          <ng-icon name="iconoirRefresh" size="16" />
          Réessayer
        </button>
      </div>
    }

    @if (isEmpty()) {
      <div class="session-history__empty">
        <span>Vos échanges avec Koffi apparaîtront ici.<br>Posez votre première question pour commencer.</span>
      </div>
    }

    @if (hasSessions()) {
      <ul class="session-history__list">
        @for (session of sessions(); track session.id) {
          <li class="session-history__item">
            @if (isConfirming(session.id)) {
              <div class="session-history__confirm">
                <span class="session-history__confirm-label">Supprimer ?</span>
                <button
                  type="button"
                  class="session-history__confirm-btn session-history__confirm-btn--yes"
                  aria-label="Confirmer la suppression de la conversation"
                  (click)="onConfirmDelete($event, session)"
                >
                  Oui
                </button>
                <button
                  type="button"
                  class="session-history__confirm-btn session-history__confirm-btn--no"
                  aria-label="Annuler la suppression de la conversation"
                  (click)="onCancelDelete($event, session.id)"
                >
                  Non
                </button>
              </div>
            } @else {
              <div class="session-history__item-row">
                <button
                  type="button"
                  class="session-history__item-btn"
                  (click)="onSelect(session)"
                >
                  <span class="session-history__item-title">{{ formatTitle(session) }}</span>
                  <span class="session-history__item-date">{{ formatRelative(session) }}</span>
                </button>

                <button
                  type="button"
                  class="session-history__delete-btn"
                  aria-label="Supprimer la conversation"
                  (click)="onRequestDelete($event, session)"
                >
                  <ng-icon name="iconoirTrash" size="16" />
                </button>
              </div>
            }

            @if (hasError(session.id)) {
              <p class="session-history__item-error">Échec de la suppression, réessayez.</p>
            }
          </li>
        }
      </ul>
    }
  </div>
</div>
